import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import SearchCouponListModal from '../../../../views/coupon/common/modal/SearchCouponListModal';
import withModal from '../../../../lib/hoc/withModal';
import { asyncSimpleModal } from '../../../../lib/common';
import { couponActions } from '../../../../store/modules/coupon';
import {
  COUPON_LIST_FILTER_OPTION_MODEL,
  COUPON_LIST_SORT_OPTION_MODEL,
} from '../../../../store/modules/coupon/models';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import { MAXIMUM_NUMBER_OF_COUPON_KIND } from '../../../../constants/service/app/couponConstants';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../../constants/service/common/utilConstants';

class SearchCouponListModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //--> 선택된 발급할 쿠폰 리스트
      selectedCouponList: [],
    };
  }

  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    this.getList({
      filterOption: COUPON_LIST_FILTER_OPTION_MODEL,
      sortOption: COUPON_LIST_SORT_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });

    this.setData({
      name: 'selectedCouponList',
      value: [],
    });
  };

  /**
   * 쿠폰 선택하기
   */
  onSubmit = async () => {
    const { selectedCouponList } = this.state;
    const { getSearchCouponResult, couponList } = this.props;
    const { selectedCouponIdList } = couponList;

    if (!selectedCouponList || !selectedCouponList.length) {
      message.error('선택된 쿠폰이 없습니다.');
      return;
    }

    /**
     *  발급할 쿠폰 종류는 20 개가 최대
     *  그 이상은 엑셀 업로드를 이용하라고 안내한다.
     */
    if (selectedCouponIdList.length + selectedCouponList.length > MAXIMUM_NUMBER_OF_COUPON_KIND) {
      await asyncSimpleModal({
        type: 'error',
        title: '엑셀 일괄 발급 권장',
        message: `발급할 쿠폰 종류가 너무 많습니다.\n ${MAXIMUM_NUMBER_OF_COUPON_KIND}건 이상은 엑셀 일괄발급을 이용해 주세요.`,
      });
      return;
    }

    getSearchCouponResult({
      couponIdList: selectedCouponList,
    });

    /**
     * 모달 닫기
     */
    this.closeModal();
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'searchCouponListModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 발급할 쿠폰 리스트 가져오기
   */
  getList = (option) => {
    const { getIssuedCouponList, data } = this.props;
    const { filterOption, sortOption, pagination } = data.listData;

    getIssuedCouponList({
      filterOption,
      sortOption,
      pagination,
      ...option,
    });
  };

  /**
   * 발급할 쿠폰 선택 callback
   */
  onCheckIssuedCoupon = (list) => {
    this.setData({
      name: 'selectedCouponList',
      value: list,
    });
  };

  /**
   *  엑셀 다운로드
   */
  getExcelDownload = () => {
    const { data, getCouponListExcelDownload } = this.props;
    const { list, filterOption, sortOption } = data.listData;

    if (!list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getCouponListExcelDownload({
      filterOption,
      sortOption,
    });
  };

  render() {
    return (
      <SearchCouponListModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
        onCheckIssuedCoupon={this.onCheckIssuedCoupon}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.coupon.searchCouponListModal.isOpen,
    data: state.coupon.searchCouponListModal.data,
    couponList: state.coupon.couponGenerate.couponList,
  };
};

const mapDispatchToProps = {
  getIssuedCouponList: couponActions.getIssuedCouponList,
  getSearchCouponResult: couponActions.getSearchCouponResult,
  getCouponListExcelDownload: couponActions.getCouponListExcelDownload,
  toggleModal: couponActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchCouponListModalContainer));
